import PageHero from "@/components/shared/PageHero";
import CTASection from "@/components/sections/CTASection";
import { ASSETS, BRAND } from "@/lib/brand";
import { CheckCircle2 } from "lucide-react";

const INCLUDED = [
  {
    t: "Instant Indicative Value",
    b: "A data-driven estimate of your property's current market value, powered by the ERA EValue engine.",
  },
  {
    t: "Personalised Interpretation",
    b: "I'll walk you through what the number really means in your specific context — financing, timing and next moves.",
  },
  {
    t: "Comparable Transactions",
    b: "Recent transactions in your block, project, or neighbourhood — so you can sense-check the figure with real data.",
  },
  {
    t: "Upgrading & Investment Lens",
    b: "If you're thinking of selling, upgrading or unlocking equity, we discuss the strategy that fits your life stage.",
  },
];

export default function PropertyValuationPage() {
  return (
    <div data-testid="page-property-valuation">
      <PageHero
        eyebrow="Property Valuation"
        title={<>Know exactly <span className="italic text-bronze">what your home is worth.</span></>}
        sub="An instant, data-driven valuation — paired with a personalised consultation to interpret the numbers in your context."
        image={ASSETS.lifestyle.agreement}
        ctas={[
          { label: "Get Property Valuation", href: BRAND.valuationLink, variant: "primary" },
          { label: "WhatsApp Kiap", href: BRAND.whatsapp, variant: "secondary" },
        ]}
        meta={[
          { label: "Powered by", value: "ERA EValue" },
          { label: "Response", value: "Instant" },
          { label: "Consultation", value: "Complimentary" },
        ]}
      />

      {/* What's included — different from the hero so no repetition */}
      <section data-testid="valuation-included" className="section-pad bg-beige/60">
        <div className="container-page">
          <div className="max-w-2xl">
            <div className="eyebrow mb-4 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-bronze" /> What you'll receive
            </div>
            <h2 className="font-serif text-4xl md:text-5xl text-ink leading-[1.05]">
              More than a number — <span className="italic text-bronze">a clear next step.</span>
            </h2>
          </div>

          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
            {INCLUDED.map((item, i) => (
              <div
                key={item.t}
                data-testid={`valuation-included-${i}`}
                className="reveal flex gap-5 border border-bronze/25 bg-cream p-7"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <CheckCircle2 className="shrink-0 text-bronze mt-1" size={22} />
                <div>
                  <h3 className="font-serif text-2xl text-ink leading-tight">{item.t}</h3>
                  <p className="mt-2 text-sm font-light leading-relaxed text-ink_soft/80">
                    {item.b}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
